import React from "react";
import { DeliveryController } from "./DeliveryController";
import { DeliveryViewModel } from "./DeliveryViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class DeliveryProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new DeliveryViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <DeliveryController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/DeliveryProvider.js